import type { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@/shared/components/feedback/Toast';
import { ThemeProvider } from '@/shared/hooks/theme-provider';
import { AuthProvider } from '@/features/auth/AuthProvider';

export interface AppProvidersProps {
  readonly children: ReactNode;
}

/** Pile de providers applicatifs (thème, cache serveur, toasts, auth). */
export function AppProviders({ children }: AppProvidersProps) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
    },
  });

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>{children}</AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
